import React, { Component } from 'react';
import PhoneInput from 'react-phone-number-input/max';
import styled, { css } from 'styled-components';

const StyledPhoneInput = styled(PhoneInput)`
  & > input {
    width: 100%;
    height: 33px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding: 0.375rem 0.75rem;
    ${(props) => props.disabled && css`
      background-color: #FAFAFA;
      border: 1px solid #DEE1EC;
    `}
  }
  &  .PhoneInputCountryIcon {
    border: 1px solid #d9d9d9;
    padding: 8px;
    box-sizing: content-box;
    border-radius: 4px;
    background: white;
    box-shadow: none;
    ${(props) => props.disabled && css`
      background-color: #FAFAFA;
      border: 1px solid #DEE1EC;
    `}
  }
`;

const StyledPhoneInputV2 = styled(PhoneInput)`
  & > input {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #D9D9D9 !important;
    padding: 10px 16px 10px 16px !important;
    outline: none;
    &:hover,
    &:focus {
      box-shadow: none !important;
      border-color: #464D5D !important;
    }
    ${(props) => props.disabled && css`
      background-color: #FAFAFA;
      border: 1px solid #DEE1EC;
    `}
  }
  &  .PhoneInputCountryIcon {
    border: 1px solid #d9d9d9;
    padding: 8px;
    box-sizing: content-box;
    border-radius: 8px;
    background: white;
    box-shadow: none;
    ${(props) => props.disabled && css`
      background-color: #FAFAFA;
      border: 1px solid #DEE1EC;
    `}
  }
`;
class PhoneNumberInput extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.isOnboardingV2 = window.isOnboardingV2 === 'true';
  }

  render() {
    if (this.isOnboardingV2) {
      return (
        <StyledPhoneInputV2
          defaultCountry="US"
          placeholder="Enter phone number"
          {...this.props}
        />
      );
    }
    return (
      <StyledPhoneInput
        defaultCountry="US"
        placeholder="Enter phone number"
        {...this.props}
      />
    );
  }
}

export default PhoneNumberInput;
